import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Vb Cannabis - Your Trusted Source for Cannabis Knowledge" 
          className="hero-image" 
        />
        <p className="eyebrow">Vb Cannabis</p>
        <h1>Your Trusted Source for Cannabis Policy and Culture</h1>
        <p className="lede">
          Delivering the latest news and insights on cannabis law and culture in your community.
        </p>
        <div className="cta-row">
          <a href="/resources" className="primary">
            Explore Our Resources
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Cannabis Law Updates</h2>
          <p>
            Stay updated on the latest changes in cannabis legislation and policy in your area.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Get clear information about the legal status of cannabis and what it means for you.
          </p>
        </article>
        <article>
          <h2>Educational Content</h2>
          <p>
            Access informative articles that cover various aspects of cannabis culture and its implications.
          </p>
        </article>
        <article>
          <h2>Community Insights</h2>
          <p>
            Learn about local events, discussions, and initiatives that shape the cannabis landscape.
          </p>
        </article>
        <article>
          <h2>Policy Analysis</h2>
          <p>
            Dive into expert analyses of cannabis policies and their impact on society.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;